exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_MediaSelectorContainer_3k79TdHbVY5WuoLi2xPbp3 {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_MediaSelectorContainer": "IA_MediaSelectorContainer_3k79TdHbVY5WuoLi2xPbp3"
};